import React from "react";

export const EtgsContext = React.createContext();

export const EtgsContextProvider = EtgsContext.Provider;

export const EtgsContextConsumer = EtgsContext.Consumer;

export const withContext = function(Component) {
  return props => (
    <EtgsContext.Consumer>
      {value => <Component context={value} {...props} />}
    </EtgsContext.Consumer>
  );
};
